import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)

    return (
        <svg
            width={200}
            height={200}
            viewBox="0 0 200 200"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
        <path
            d="M20 105.088a79.997 79.997 0 0080 80 80.002 80.002 0 0056.569-136.569A80.001 80.001 0 0020 105.088z"
            fill={theme["#F4FFFE"]}
        />
        <path
            d="M29.439 151.426c0 .875 2.55 1.715 7.087 2.333 4.539.619 10.694.967 17.112.967 6.419 0 12.574-.348 17.113-.967 4.538-.618 7.087-1.458 7.087-2.333 0-.875-2.55-1.715-7.087-2.333-4.539-.619-10.694-.967-17.113-.967-6.418 0-12.573.348-17.111.967-4.539.618-7.088 1.458-7.088 2.333z"
            fill={theme["#DCFFFD"]}
            fillOpacity={0.9}
        />
        <path
            d="M94.548 123.486v10.56a5.277 5.277 0 01-3.261 4.879 5.27 5.27 0 01-2.021.401H18a5.278 5.278 0 01-5.278-5.28v-10.56h81.826z"
            fill="#fff"
            stroke={theme["#0EA59D"]}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M56.278 131.4a2.64 2.64 0 01-3.157 2.593 2.64 2.64 0 01-1.925-3.603 2.641 2.641 0 015.082 1.01zM66.838 149.886h-26.4l1.319-10.56h23.762l1.32 10.56z"
            fill="#fff"
            stroke={theme["#0EA59D"]}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M32.518 149.886h42.238"
            stroke={theme["#0EA59D"]}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M94.556 123.486v-42.24a5.281 5.281 0 00-5.282-5.28H18a5.28 5.28 0 00-5.278 5.28v42.24h81.834z"
            fill={theme["#DCFFFD"]}
            fillOpacity={0.9}
            stroke={theme["#0EA59D"]}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M122.162 151.428c0 .875 2.55 1.715 7.088 2.333 4.539.619 10.694.967 17.112.967 6.418 0 12.574-.348 17.112-.967 4.538-.618 7.088-1.458 7.088-2.333 0-.875-2.55-1.715-7.088-2.334-4.538-.618-10.694-.966-17.112-.966-6.418 0-12.573.348-17.112.966-4.538.619-7.088 1.459-7.088 2.334z"
            fill={theme["#DCFFFD"]}
            fillOpacity={0.9}
        />
        <path
            d="M187.274 123.488v10.558a5.277 5.277 0 01-5.274 5.282h-71.278a5.264 5.264 0 01-3.733-1.547 5.285 5.285 0 01-1.545-3.735v-10.558h81.83z"
            fill="#fff"
            stroke={theme["#0EA59D"]}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M149 131.4a2.646 2.646 0 01-1.63 2.442 2.64 2.64 0 01-3.603-1.924A2.643 2.643 0 11149 131.4zM159.562 149.888h-26.4l1.32-10.56h23.762l1.318 10.56z"
            fill="#fff"
            stroke={theme["#0EA59D"]}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M125.244 149.888h42.238-42.238z" fill="#fff" />
        <path
            d="M125.244 149.888h42.238"
            stroke={theme["#0EA59D"]}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M187.282 123.488V81.246a5.281 5.281 0 00-5.282-5.28h-71.278a5.28 5.28 0 00-5.278 5.28v42.242h81.838z"
            fill={theme["#DCFFFD"]}
            fillOpacity={0.9}
            stroke={theme["#0EA59D"]}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M59.365 73.93l6.653-26.918a2.234 2.234 0 012.705-1.633l47.745 11.802a2.235 2.235 0 011.635 2.705l-6.654 26.918a2.233 2.233 0 01-2.707 1.634l-47.743-11.8a2.236 2.236 0 01-1.634-2.708z"
            fill="#fff"
            stroke={theme["#0EA59D"]}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M108.28 77.268l2.574-10.416a5.368 5.368 0 01-3.922-6.496L75.684 52.63a5.368 5.368 0 01-6.496 3.922l-2.576 10.416a5.366 5.366 0 013.92 6.496l31.252 7.736a5.36 5.36 0 012.433-3.313 5.363 5.363 0 014.063-.62z"
            fill={theme["#DCFFFD"]}
            fillOpacity={0.9}
            stroke={theme["#0EA59D"]}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M93.94 68.2a5.363 5.363 0 11-10.412-2.577A5.363 5.363 0 0193.94 68.2z"
            fill="#fff"
            stroke={theme["#0EA59D"]}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M24.722 81.95h55.956v28.696H24.722V81.95z"
            fill={theme["#DCFFFD"]}
            fillOpacity={0.9}
            stroke={theme["#0EA59D"]}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M19.7 110.646h66v5.74h-66v-5.74zM48.397 86.35h8.608v19.896h-8.608V86.35zM72.07 86.35h8.608v19.896H72.07V86.35zM23.706 76.928c-.27.43-.415.926-.42 1.434v3.588h58.828v-3.588a2.751 2.751 0 00-.42-1.434H23.706zM32.742 76.928l18.282-13.144a2.878 2.878 0 013.352 0l18.282 13.144h9.036a2.75 2.75 0 00-.752-.828L54.356 57.3a2.868 2.868 0 00-3.312 0L24.458 76.1c-.305.221-.56.503-.752.828h9.036z"
            fill="#fff"
            stroke={theme["#0EA59D"]}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M51.024 63.785L32.742 76.928h39.916L54.376 63.784a2.878 2.878 0 00-3.352 0z"
            fill={theme["#DCFFFD"]}
            fillOpacity={0.9}
            stroke={theme["#0EA59D"]}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M24.722 86.35h8.608v19.896h-8.608V86.35z"
            fill="#fff"
            stroke={theme["#0EA59D"]}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M36.2 108.446a2.2 2.2 0 01-2.2 2.2h-9.948a2.202 2.202 0 01-2.2-2.2 2.202 2.202 0 012.2-2.2H34a2.192 2.192 0 011.555.644 2.208 2.208 0 01.645 1.556zM69.2 108.446a2.2 2.2 0 002.2 2.2h9.948a2.202 2.202 0 002.2-2.2 2.202 2.202 0 00-2.2-2.2H71.4a2.202 2.202 0 00-2.2 2.2zM59.874 108.446a2.2 2.2 0 01-2.2 2.2h-9.948a2.202 2.202 0 01-2.2-2.2 2.203 2.203 0 012.2-2.2h9.948a2.202 2.202 0 012.2 2.2zM36.2 84.15a2.2 2.2 0 01-2.2 2.2h-9.948a2.2 2.2 0 010-4.4H34a2.2 2.2 0 012.2 2.2zM69.2 84.15a2.2 2.2 0 002.2 2.2h9.948a2.2 2.2 0 100-4.4H71.4a2.2 2.2 0 00-2.2 2.2zM59.874 84.15a2.2 2.2 0 01-2.2 2.2h-9.948a2.2 2.2 0 010-4.4h9.948a2.2 2.2 0 012.2 2.2zM56.184 39.126A4.037 4.037 0 0159.21 36.1l6.076-1.4a.506.506 0 000-.984l-6.076-1.4a4.034 4.034 0 01-3.026-3.026l-1.4-6.072a.505.505 0 00-.984 0l-1.4 6.072a4.046 4.046 0 01-3.028 3.028l-6.072 1.4a.506.506 0 000 .984l6.072 1.4a4.033 4.033 0 013.028 3.024l1.4 6.076a.506.506 0 00.984 0l1.4-6.076zM128.038 38.2a5.767 5.767 0 014.32-4.322l8.674-2a.72.72 0 000-1.4l-8.674-2a5.765 5.765 0 01-4.322-4.322l-2-8.667a.719.719 0 00-.7-.546.718.718 0 00-.7.546l-2 8.668a5.768 5.768 0 01-4.322 4.322l-8.668 2a.72.72 0 000 1.4l8.668 2a5.767 5.767 0 014.316 4.322l2 8.673a.726.726 0 00.7.546.723.723 0 00.7-.546l2.008-8.674zM109.634 82.286c0 .676.184 1.339.532 1.918l1.736 2.896a19.822 19.822 0 0016.898 9.57h1.6a3.728 3.728 0 003.73-3.73 3.728 3.728 0 00-3.73-3.73h-1.6a12.32 12.32 0 01-10.51-5.948l-1.738-2.898a3.726 3.726 0 00-6.168-.338 3.732 3.732 0 00-.758 2.26h.008z"
            fill="#fff"
            stroke={theme["#0EA59D"]}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M158.852 109.744v13.744h-21.97v-15.31a8.604 8.604 0 00-1.294-4.778 9.991 9.991 0 01-2.066-5.524h-7.424V88.3h21.312a18.397 18.397 0 0118.4 18.4v3.042l-6.958.002z"
            fill="#fff"
            stroke={theme["#0EA59D"]}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M158.848 109.744h6.964v13.744h-6.964v-13.744z"
            fill="#fff"
            stroke={theme["#0EA59D"]}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M147.41 94.692v28.796"
            stroke={theme["#0EA59D"]}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M152.954 89.15l-5.544 5.542 4.236 2.826a2.133 2.133 0 003.154-.958l2.286-5.514a18.327 18.327 0 00-4.132-1.896zM143.174 97.518l4.236-2.826-6.084-6.4h-4.6l3.304 8.26a2.124 2.124 0 001.344 1.224 2.132 2.132 0 001.8-.258z"
            fill="#fff"
            stroke={theme["#0EA59D"]}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M158.848 109.744a7.114 7.114 0 011.254-3.244 7.116 7.116 0 001.066-3.89"
            stroke={theme["#0EA59D"]}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M152.954 89.152a1.8 1.8 0 01-1.252-1.712v-8.884h-9.122v8.498a1.245 1.245 0 01-1.246 1.246l6.084 6.4 5.536-5.548zM148.324 59.724a5.75 5.75 0 01-9.642-5.74 5.751 5.751 0 019.561 1.933 5.75 5.75 0 01.081 3.807z"
            fill="#fff"
            stroke={theme["#0EA59D"]}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M145.694 58.456a5.145 5.145 0 007.086-1.186 5.144 5.144 0 00.4-7.174 5.143 5.143 0 00-7.086 1.186 5.143 5.143 0 00-.4 7.174z"
            fill="#fff"
            stroke={theme["#0EA59D"]}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M134.318 69.516c0 3.57 1.38 6.993 3.835 9.517 2.455 2.525 5.785 3.943 9.257 3.943 3.473 0 6.803-1.418 9.258-3.943 2.455-2.524 3.834-5.948 3.834-9.517 0-3.57-1.379-6.994-3.834-9.518-2.455-2.524-5.785-3.942-9.258-3.942-3.472 0-6.802 1.418-9.257 3.942s-3.835 5.948-3.835 9.518z"
            fill="#fff"
            stroke={theme["#0EA59D"]}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M158.348 70.962a.94.94 0 00-.68-.264c-5.66.168-12.944-.946-15.882-5.668-.376 3.686-2.244 5.304-4.766 5.582a.93.93 0 00-.83.93v1.532a2.29 2.29 0 00.234 4.534 11.22 11.22 0 0018.066 6.418c2-1.627 3.38-3.893 3.906-6.418a2.292 2.292 0 001.616-3.7 2.291 2.291 0 00-1.38-.834v-1.498a.868.868 0 00-.284-.614z"
            fill="#fff"
            stroke={theme["#0EA59D"]}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M139.93 76.72a1.4 1.4 0 102.802.002 1.4 1.4 0 00-2.802-.002zM152.086 76.72a1.392 1.392 0 00.411.992 1.396 1.396 0 001.527.304 1.39 1.39 0 00.759-.76 1.392 1.392 0 000-1.072 1.398 1.398 0 00-1.295-.866 1.407 1.407 0 00-.991.411 1.392 1.392 0 00-.411.991z"
            fill={theme["#DCFFFD"]}
            fillOpacity={0.9}
        />
        <path
            d="M150.216 80a4.673 4.673 0 01-5.616 0"
            stroke={theme["#0EA59D"]}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M142.522 73.214a1.223 1.223 0 102.446 0 1.223 1.223 0 00-2.446 0zM149.856 73.214a1.223 1.223 0 102.446 0 1.223 1.223 0 00-2.446 0z"
            fill={theme["#0EA59D"]}
        />
        </svg>
    )
}

export default SvgComponent
